import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('organizationWorkspace');

    return {
        ADD_AIRCRAFT: t('addAircraft'),
        ADD_CONTROLLER: t('addController'),
        ADDRESS: t('address'),
        AIRCRAFT: t('aircraft'),
        CERTIFICATE_OF_AUTHORIZATION_NUMBER: t('certificateOfAuthorizationNumber'),
        CERTIFICATIONS: t('certifications'),
        CITY: t('city'),
        COMPANY_DETAILS: t('companyDetails'),
        COMPANY_NAME: t('companyName'),
        CONTACT_NAME: t('contactName'),
        CONTROLLERS: t('controllers'),
        DETAILS: t('details'),
        EDIT: t('edit'),
        EMAIL: t('email'),
        EQUIPMENT: t('equipment'),
        EQUIPMENT_SUBTITLE: t('equipmentSubtitle'),
        FAA_DOCKET_NUMBER: t('faaDocketNumber'),
        FAA_EXEMPTION_NUMBER: t('faaExemptionNumber'),
        INVITATIONS: t('invitations'),
        INVITE_USER: t('inviteUser'),
        NOT_PROVIDED: t('notProvided'),
        ORGANIZATION: t('organization'),
        ORGANIZATION_SUBTITLE: t('organizationSubtitle'),
        PERSON_OF_CONTACT: t('personOfContact'),
        PHONE: t('phone'),
        STATE: t('state'),
        SUBSCRIPTION: t('subscription'),
        USERS: t('users'),
        USERS_SUBTITLE: t('usersSubtitle'),
        ZIP: t('zip')
    };
};

export default useTranslation;
